import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_2 = {
  key: 1,
  class: "p-5"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  key: 0,
  class: "col-3 mb-5"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bold text-dark" }, "Prefill Base Schema", -1)
const _hoisted_6 = {
  key: 1,
  class: "col-3 mb-5"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bold text-dark" }, "Prefill Rebate Schema", -1)
const _hoisted_8 = {
  key: 2,
  class: "col-3 mb-5"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bold text-dark" }, "Prefill Rate", -1)
const _hoisted_10 = {
  key: 3,
  class: "col-3 mb-5"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bold text-dark" }, "Prefill Pips", -1)
const _hoisted_12 = {
  key: 4,
  class: "col-3 mb-5"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bold text-dark" }, "Prefill Commission", -1)
const _hoisted_14 = { class: "mt-11" }
const _hoisted_15 = {
  key: 0,
  class: "fv-row mb-7"
}
const _hoisted_16 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold mb-8" }
const _hoisted_17 = { class: "nav-item" }
const _hoisted_18 = { class: "nav-item" }
const _hoisted_19 = { class: "nav-item" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-5 mb-5" }, null, -1)
const _hoisted_21 = { class: "row mb-9" }
const _hoisted_22 = { class: "col-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-semobold mb-2 createAccountTitle" }, " New Schema Name ", -1)
const _hoisted_24 = { class: "col-9" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-semobold mb-2 createAccountTitle" }, " Note ", -1)
const _hoisted_26 = { class: "mt-13 d-flex flex-row-reverse" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-light btn-danger btn-lg me-3 mb-9" }, " Cancel ", -1)

import { ref, nextTick } from "vue";
import { computedAsync } from "@vueuse/core";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import SimpleForm from "@/components/SimpleForm.vue";
import { Field, ErrorMessage, useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import RebateService from "../../rebate/services/RebateService";
import { RebateSchemaType } from "@/core/types/RebateSchemaType";
import CategorySymbolsCollapse from "./CategorySymbolsCollapse.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddNewRebateSchema',
  emits: ["refresh"],
  setup(__props, { expose: __expose, emit: emits }) {



const applyCategoryForm = ref({
  rate: {},
  commission: {},
  pips: {},
  bundleVal: {},
});

const reset = () => {
  applyCategoryForm.value = {
    rate: {},
    commission: {},
    pips: {},
    bundleVal: {},
  };

  formTab.value = "rate";
  schemaInfo.value.schemaName = "";
  schemaInfo.value.schemaNote = "";
};

const modalRef = ref<InstanceType<typeof SimpleForm>>();

const isLoading = ref(true);

const schemaInfo = ref({
  schemaName: "",
  schemaNote: "",
});

const editableRebateSchema = ref<any>({});
const originalRebateSchema = ref<any>({});
const formTab = ref("rate");
const { t } = useI18n();
const schemaType = ref(0);
const categoryMap = ref({});
const currentDropdown = ref(0);

const show = async (_schemaType: number) => {
  modalRef.value?.show();
  isLoading.value = true;
  schemaType.value = _schemaType;

  await setupDropdownOptions();

  try {
    const res = await RebateService.getSymbolsList();

    originalRebateSchema.value = res.reduce((acc, item) => {
      const category = item.category;

      if (!acc[category]) {
        acc[category] = {};
      }

      if (
        _schemaType == RebateSchemaType.Base ||
        _schemaType == RebateSchemaType.Rebate
      ) {
        acc[category][item.code] = {
          symbolCode: item.code,
          rate: 0,
          pips: 0,
          commission: 0,
        };
      } else {
        formTab.value = "bundleVal";
        acc[category][item.code] = {
          symbolCode: item.code,
          bundleVal: 0,
        };
      }

      return acc;
    }, {});

    editableRebateSchema.value = JSON.parse(
      JSON.stringify(originalRebateSchema.value)
    );

    for (const item of res) {
      categoryMap.value[item.code] = item.category;
    }
  } catch (error) {
    MsgPrompt.error(error);
  }

  isLoading.value = false;
};

const remoteMethod = async (query: string) => {
  if (query) {
    schemaInfo.value[currentDropdown.value]["loading"] = true;

    const _handler = {
      [RebateSchemaType.Rebate]: () =>
        RebateService.getRebateSchemaList({
          keyword: query,
        }),
      [RebateSchemaType.Base]: () =>
        RebateService.getBaseSchemaList({ keyword: query }),
      [RebateSchemaType.Rate]: () =>
        RebateService.getBundleList({
          type: RebateSchemaType.Rate,
          keyword: query,
        }),
      [RebateSchemaType.Pips]: () =>
        RebateService.getBundleList({
          type: RebateSchemaType.Pips,
          keyword: query,
        }),
      [RebateSchemaType.Commission]: () =>
        RebateService.getBundleList({
          type: RebateSchemaType.Commission,
          keyword: query,
        }),
    }[currentDropdown.value];
    if (!_handler) {
      MsgPrompt.error(t("tip.fail"));
      return;
    }

    const options = await _handler();
    schemaInfo.value[currentDropdown.value]["options"] = options.data;
    schemaInfo.value[currentDropdown.value]["loading"] = false;
  } else {
    schemaInfo.value[currentDropdown.value]["options"] = [];
  }
};

const setupDropdownOptions = async () => {
  schemaInfo.value[RebateSchemaType.Rebate] = {};
  schemaInfo.value[RebateSchemaType.Base] = {};
  schemaInfo.value[RebateSchemaType.Rate] = {};
  schemaInfo.value[RebateSchemaType.Pips] = {};
  schemaInfo.value[RebateSchemaType.Commission] = {};

  schemaInfo.value[RebateSchemaType.Rebate]["loading"] = false;
  schemaInfo.value[RebateSchemaType.Base]["loading"] = false;
  schemaInfo.value[RebateSchemaType.Rate]["loading"] = false;
  schemaInfo.value[RebateSchemaType.Pips]["loading"] = false;
  schemaInfo.value[RebateSchemaType.Commission]["loading"] = false;
};

const preFillTemplate = async (_preFillSchemaType) => {
  if (schemaInfo.value[_preFillSchemaType].id.length == 0) {
    refillschema();
    return;
  }

  if (schemaType.value == RebateSchemaType.Base) {
    const resBase = await RebateService.getRebateBaseSchemaById(
      parseInt(schemaInfo.value[_preFillSchemaType].id)
    );
    schemaInfo.value[_preFillSchemaType].table = resBase.rebateBaseSchemaItems;
  } else if (schemaType.value == RebateSchemaType.Rebate) {
    const resRate = await RebateService.getRebateBaseSchemaById(
      parseInt(schemaInfo.value[_preFillSchemaType].id)
    );
    schemaInfo.value[_preFillSchemaType].table = resRate.rebateBaseSchemaItems;
  }

  schemaInfo.value[_preFillSchemaType].table.forEach(function (item) {
    editableRebateSchema.value[categoryMap.value[item.symbolCode]][
      item.symbolCode
    ] = {
      symbolCode: item.symbolCode,
      rate: item.rate,
      pips: item.pips,
      commission: item.commission,
    };
  });
};

const preFillBundle = async (_preFillSchemaType: number) => {
  if (schemaInfo.value[_preFillSchemaType].id.length == 0) {
    refillschema();
    return;
  }

  schemaInfo.value[_preFillSchemaType].table =
    await RebateService.getRebateSchemaBundleById(
      parseInt(schemaInfo.value[_preFillSchemaType].id)
    );

  const symbols = Object.keys(schemaInfo.value[_preFillSchemaType].table.items);

  for (const symbol of symbols) {
    if (
      schemaType.value == RebateSchemaType.Rebate ||
      schemaType.value == RebateSchemaType.Base
    ) {
      switch (_preFillSchemaType) {
        case RebateSchemaType.Rate:
          editableRebateSchema.value[categoryMap.value[symbol]][symbol][
            "rate"
          ] = schemaInfo.value[_preFillSchemaType].table.items[symbol];
          break;
        case RebateSchemaType.Pips:
          editableRebateSchema.value[categoryMap.value[symbol]][symbol][
            "pips"
          ] = schemaInfo.value[_preFillSchemaType].table.items[symbol];
          break;
        case RebateSchemaType.Commission:
          editableRebateSchema.value[categoryMap.value[symbol]][symbol][
            "commission"
          ] = schemaInfo.value[_preFillSchemaType].table.items[symbol];
          break;
      }
    } else {
      editableRebateSchema.value[categoryMap.value[symbol]][symbol] = {
        symbolCode: symbol,
        bundleVal: schemaInfo.value[_preFillSchemaType].table.items[symbol],
      };
    }
  }
};

const refillschema = async () => {
  editableRebateSchema.value = JSON.parse(
    JSON.stringify(originalRebateSchema.value)
  );

  if (
    schemaType.value == RebateSchemaType.Base &&
    schemaInfo.value[RebateSchemaType.Base].id.length != 0
  ) {
    await preFillTemplate(RebateSchemaType.Base);
  } else if (
    schemaType.value == RebateSchemaType.Rebate &&
    schemaInfo.value[RebateSchemaType.Rebate].id.length != 0
  ) {
    await preFillTemplate(RebateSchemaType.Rebate);
  }

  if (schemaInfo.value[RebateSchemaType.Rate].id.length != 0) {
    await preFillBundle(RebateSchemaType.Rate);
  }

  if (schemaInfo.value[RebateSchemaType.Pips].id.length != 0) {
    await preFillBundle(RebateSchemaType.Pips);
  }

  if (schemaInfo.value[RebateSchemaType.Commission].id.length != 0) {
    await preFillBundle(RebateSchemaType.Commission);
  }
};

const postSchema = async () => {
  const data = {
    RebateRuleItems: Object.keys(editableRebateSchema.value).reduce(
      (result: any, category) => {
        const symbols = editableRebateSchema.value[category];
        Object.keys(symbols).forEach((symbol) => {
          // If the schema type is Base || Rebate
          if (
            schemaType.value == RebateSchemaType.Base ||
            schemaType.value == RebateSchemaType.Rebate
          ) {
            const { symbolCode, rate, pips, commission } = symbols[symbol];
            result.push({ symbolCode, rate, pips, commission });
          } else {
            result[symbols[symbol].symbolCode] = symbols[symbol].bundleVal;
          }
        });
        return result;
      },
      schemaType.value == RebateSchemaType.Base ||
        schemaType.value == RebateSchemaType.Rebate
        ? []
        : {}
    ),
  };

  try {
    if (schemaType.value == RebateSchemaType.Rebate) {
      await RebateService.postRebateSchema({
        name: schemaInfo.value.schemaName,
        note: schemaInfo.value.schemaNote,
        items: data.RebateRuleItems,
      });
    } else if (schemaType.value == RebateSchemaType.Base) {
      await RebateService.postRebateBaseSchema({
        name: schemaInfo.value.schemaName,
        note: schemaInfo.value.schemaNote,
        items: data.RebateRuleItems,
      });
    } else {
      await RebateService.postRebateSchemaBundle({
        name: schemaInfo.value.schemaName,
        note: schemaInfo.value.schemaNote,
        type: schemaType.value,
        items: data.RebateRuleItems,
      });
    }

    MsgPrompt.success(t("tip.submitSuccess")).then(() => {
      emits("refresh");
      hide();
      reset();
    });
  } catch (error) {
    MsgPrompt.error(error);
  }
};

const hide = () => {
  modalRef.value?.hide();
};

const onUpdateSymbol = ({
  category,
  symbolKey,
  formTab: tab,
  value,
}: {
  category: string;
  symbolKey: string;
  formTab: string;
  value: any;
}) => {
  if (
    editableRebateSchema.value?.[category]?.[symbolKey] &&
    editableRebateSchema.value[category][symbolKey][tab] !== undefined
  ) {
    editableRebateSchema.value[category][symbolKey][tab] = value;
  }
};

const onApplyCategory = ({
  category,
  formTab: tab,
  value,
}: {
  category: string;
  formTab: string;
  value: any;
}) => {
  Object.keys(editableRebateSchema.value[category]).forEach((symbolKey) => {
    editableRebateSchema.value[category][symbolKey][tab] = value;
  });
};

const onUpdateApplyInput = ({
  category,
  formTab: tab,
  value,
}: {
  category: string;
  formTab: string;
  value: any;
}) => {
  if (!applyCategoryForm.value[tab]) applyCategoryForm.value[tab] = {};
  applyCategoryForm.value[tab][category] = value;
};

__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalRef",
    ref: modalRef,
    title: 'New Rebate Schema / Template',
    "is-loading": isLoading.value,
    width: 1300,
    "disable-footer": ""
  }, {
    default: _withCtx(() => [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_LoadingRing)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (
            schemaType.value === _unref(RebateSchemaType).Base ||
            schemaType.value === _unref(RebateSchemaType).Rebate
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _hoisted_5,
                    _createVNode(_component_el_select, {
                      modelValue: schemaInfo.value[_unref(RebateSchemaType).Base].id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((schemaInfo.value[_unref(RebateSchemaType).Base].id) = $event)),
                      filterable: "",
                      clearable: "",
                      remote: "",
                      "reserve-keyword": "",
                      placeholder: "Please enter a keyword",
                      "remote-method": remoteMethod,
                      loading: schemaInfo.value[_unref(RebateSchemaType).Base]['loading'],
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (currentDropdown.value = _unref(RebateSchemaType).Base)),
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (preFillTemplate(_unref(RebateSchemaType).Base)))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schemaInfo.value[_unref(RebateSchemaType).Base].options, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.key,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "loading"])
                  ]))
                : _createCommentVNode("", true),
              (schemaType.value === _unref(RebateSchemaType).Rebate)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _hoisted_7,
                    _createVNode(_component_el_select, {
                      modelValue: schemaInfo.value[_unref(RebateSchemaType).Rebate].id,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((schemaInfo.value[_unref(RebateSchemaType).Rebate].id) = $event)),
                      clearable: "",
                      filterable: "",
                      remote: "",
                      "reserve-keyword": "",
                      placeholder: "Please enter a keyword",
                      "remote-method": remoteMethod,
                      loading: schemaInfo.value[_unref(RebateSchemaType).Rebate]['loading'],
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (currentDropdown.value = _unref(RebateSchemaType).Rebate)),
                      onChange: _cache[5] || (_cache[5] = ($event: any) => (preFillTemplate(_unref(RebateSchemaType).Rebate)))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schemaInfo.value[_unref(RebateSchemaType).Rebate].options, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.key,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "loading"])
                  ]))
                : _createCommentVNode("", true),
              (
            schemaType.value === _unref(RebateSchemaType).Base ||
            schemaType.value === _unref(RebateSchemaType).Rebate ||
            schemaType.value === _unref(RebateSchemaType).Rate
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_el_select, {
                      modelValue: schemaInfo.value[_unref(RebateSchemaType).Rate].id,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((schemaInfo.value[_unref(RebateSchemaType).Rate].id) = $event)),
                      clearable: "",
                      filterable: "",
                      remote: "",
                      "reserve-keyword": "",
                      placeholder: "Please enter a keyword",
                      "remote-method": remoteMethod,
                      loading: schemaInfo.value[_unref(RebateSchemaType).Rate]['loading'],
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (currentDropdown.value = _unref(RebateSchemaType).Rate)),
                      onChange: _cache[8] || (_cache[8] = ($event: any) => (preFillBundle(_unref(RebateSchemaType).Rate)))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schemaInfo.value[_unref(RebateSchemaType).Rate].options, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.key,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "loading"])
                  ]))
                : _createCommentVNode("", true),
              (
            schemaType.value === _unref(RebateSchemaType).Base ||
            schemaType.value === _unref(RebateSchemaType).Rebate ||
            schemaType.value === _unref(RebateSchemaType).Pips
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_component_el_select, {
                      modelValue: schemaInfo.value[_unref(RebateSchemaType).Pips].id,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((schemaInfo.value[_unref(RebateSchemaType).Pips].id) = $event)),
                      clearable: "",
                      filterable: "",
                      remote: "",
                      "reserve-keyword": "",
                      placeholder: "Please enter a keyword",
                      "remote-method": remoteMethod,
                      loading: schemaInfo.value[_unref(RebateSchemaType).Pips]['loading'],
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (currentDropdown.value = _unref(RebateSchemaType).Pips)),
                      onChange: _cache[11] || (_cache[11] = ($event: any) => (preFillBundle(_unref(RebateSchemaType).Pips)))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schemaInfo.value[_unref(RebateSchemaType).Pips].options, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.key,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "loading"])
                  ]))
                : _createCommentVNode("", true),
              (
            schemaType.value === _unref(RebateSchemaType).Base ||
            schemaType.value === _unref(RebateSchemaType).Rebate ||
            schemaType.value === _unref(RebateSchemaType).Commission
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _hoisted_13,
                    _createVNode(_component_el_select, {
                      modelValue: schemaInfo.value[_unref(RebateSchemaType).Commission].id,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((schemaInfo.value[_unref(RebateSchemaType).Commission].id) = $event)),
                      clearable: "",
                      filterable: "",
                      remote: "",
                      "reserve-keyword": "",
                      placeholder: "Please enter a keyword",
                      "remote-method": remoteMethod,
                      loading: schemaInfo.value[_unref(RebateSchemaType).Commission]['loading'],
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (currentDropdown.value = _unref(RebateSchemaType).Commission)),
                      onChange: _cache[14] || (_cache[14] = ($event: any) => (preFillBundle(_unref(RebateSchemaType).Commission)))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schemaInfo.value[_unref(RebateSchemaType).Commission].options, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.key,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "loading"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_14, [
              (
            schemaType.value === _unref(RebateSchemaType).Base ||
            schemaType.value === _unref(RebateSchemaType).Rebate
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("ul", _hoisted_16, [
                      _createElementVNode("li", _hoisted_17, [
                        _createElementVNode("a", {
                          class: _normalizeClass(["nav-link text-active-primary pb-4", { active: formTab.value === 'rate' }]),
                          "data-bs-toggle": "tab",
                          href: "#",
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (formTab.value = 'rate'))
                        }, "Rate", 2)
                      ]),
                      _createElementVNode("li", _hoisted_18, [
                        _createElementVNode("a", {
                          class: _normalizeClass(["nav-link text-active-primary pb-4", { active: formTab.value === 'pips' }]),
                          "data-bs-toggle": "tab",
                          href: "#",
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (formTab.value = 'pips'))
                        }, "Pips", 2)
                      ]),
                      _createElementVNode("li", _hoisted_19, [
                        _createElementVNode("a", {
                          class: _normalizeClass(["nav-link text-active-primary pb-4", { active: formTab.value === 'commission' }]),
                          "data-bs-toggle": "tab",
                          href: "#",
                          onClick: _cache[17] || (_cache[17] = ($event: any) => (formTab.value = 'commission'))
                        }, "Commission", 2)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createVNode(_unref(Field), {
                    modelValue: schemaInfo.value.schemaName,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((schemaInfo.value.schemaName) = $event)),
                    class: "form-control form-control-lg form-control-solid",
                    type: "number",
                    name: "symbolRule",
                    autocomplete: "off"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: schemaInfo.value.schemaName,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((schemaInfo.value.schemaName) = $event)),
                        size: "large"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(_unref(Field), {
                    modelValue: schemaInfo.value.schemaNote,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((schemaInfo.value.schemaNote) = $event)),
                    class: "form-control form-control-lg form-control-solid",
                    type: "number",
                    name: "symbolRule",
                    autocomplete: "off"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: schemaInfo.value.schemaNote,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((schemaInfo.value.schemaNote) = $event)),
                        size: "large"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createVNode(CategorySymbolsCollapse, {
                schema: editableRebateSchema.value,
                "form-tab": formTab.value,
                "apply-category-form": applyCategoryForm.value,
                "initial-collapsed": true,
                onUpdateSymbol: onUpdateSymbol,
                onApplyCategory: onApplyCategory,
                onUpdateApplyInput: onUpdateApplyInput
              }, null, 8, ["schema", "form-tab", "apply-category-form"]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("button", {
                  class: "btn btn-light btn-success btn-lg me-3 mb-9",
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (postSchema()))
                }, " Add New Schema ")
              ])
            ])
          ]))
    ]),
    _: 1
  }, 8, ["is-loading"]))
}
}

})